import { FC } from "react";
import { useData } from "data/data-provider";

export interface AboutSectionProps {
  className?: string;
}

const AboutSection: FC<AboutSectionProps> = ({ className = "" }) => {
  const { aboutUs, companyDetails } = useData();

  // Heading falls back to the company name so the hero never goes blank if
  // the tenant hasn't filled in About Us copy yet.
  const heading =
    aboutUs?.heading?.trim() || companyDetails?.company_name || "About Us";
  const description = aboutUs?.description?.trim();

  return (
    <div
      className={`nc-SectionHero relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="container mx-auto px-4 py-20 md:py-32 relative">
        <div className="mb-8">
          <div className="inline-block bg-[#FFFFFF26] border border-primary-100 rounded-full px-4 py-2">
            <nav className="flex items-center text-sm">
              <div className="text-white hover:text-primary-300">Home</div>
              <span className="mx-2 text-primary-300">›</span>
              <span className="text-white">About Us</span>
            </nav>
          </div>
        </div>

        <div className="max-w-3xl">
          <h1
            className="text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight"
            dangerouslySetInnerHTML={{ __html: heading }}
          />

          {description && (
            <div className="mt-6">
              <span
                className="text-xl text-white/80 font-semibold"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
